import React from 'react';
import PropTypes from 'prop-types';
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import {
    isEmpty,
    extractWorkSheetData,
    getWithExpiry,
    formatDate,
    ExcelDateToDateString
} from "../../globals/GlobalFunctions";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import axios from 'axios';
import {refreshToken} from "../../globals/GlobalFunctions";
import Autocomplete from "@mui/material/Autocomplete";
import {GlobalConstants} from "../../globals/GlobalConstants";
import TextField from "@mui/material/TextField";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";

export interface Props {
    excelData: any;
    currentDB: string;
}

function SubscriberIDChanger({excelData, currentDB}: Props) {
    const [successAlert, setSuccessAlert] = React.useState(false);
    const [errorAlert, setErrorAlert] = React.useState(false);
    const [validationText, setValidationText] = React.useState("");
    const [validationError, setValidationError] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const [currentSub, setCurrentSub] = React.useState({current_Subscriber_ID: "",
        new_Subscriber_ID: "", vbasoftware_database: "CoastalAdminTest", vbapi_Token: ""});

    let token = localStorage.getItem('jwt');

    const handleValidationClose = () => {
        setValidationError(false);
        setValidationText("");
    }

    const initialSubState = {
        current_Subscriber_ID: "",
        new_Subscriber_ID: "",
        vbasoftware_database: "CoastalAdminTest",
        vbapi_Token: ""
    }

    const clearSubs = () => {
        setCurrentSub({...initialSubState});
    }

    const changeSubIDs = async (subArray : any[]) => {
        refreshToken();
        setIsLoading(true);
        const response =
            await axios
                .post(
                    localStorage.getItem('baseURL') + 'subscriber/updateIDs',
                    subArray,
                    {headers: {'Authorization': `Bearer ${token}`, accept: "*/*", "Content-Type": "application/json"}}
                ).then(() => {
                    setLoading(false);
                    setSuccessAlert(true);
                    setIsLoading(false);
                }).catch((error) => {
                    //console.log(response);
                    setLoading(false);
                    setValidationText(error.response.request.responseText);
                    setValidationError(true);
                    setIsLoading(false);
                });
        //console.log(response);
    }

    try {
        //Check for data and that there is a sheet in the data named IDCodeValue
        if (!isEmpty(excelData) && excelData.Sheets.SubIDs !== undefined) {
            //console.log(excelData, "Made it to formatter!");

            //global function to extract the data into a sequential array of cell data values as well as the column and row ranges
            let sheetDataArray = extractWorkSheetData(excelData.Sheets.SubIDs);

            let rawCellArray: any[] = sheetDataArray[0];

            let columnRange: number = sheetDataArray[1];

            let rowRange: number = sheetDataArray[2];

            let subArray: any[] = [];

            //console.log(rawCellArray, "Raw Data");

            //we need to find the column index of the values we require so we can grab the data for each row -- THIS IS WHERE COLUMN NAMES ARE SET
            //we add 1 for each for the loop multiplier to account for it being zero based, but later we subtract 1 to account for the very fist row actually starting at zero
            const subIndexCollection = {
                currentSubIndex: rawCellArray.indexOf('Current Sub ID') + 1,
                newSubIndex: rawCellArray.indexOf('New Sub ID') + 1
            }

            if(subIndexCollection.currentSubIndex > 0 && subIndexCollection.newSubIndex > 0) {

                for (let i = 1; i < rowRange; i++) {
                    //for each new array we skip over the previous records determined by the column length, removing 1 to account for our zero based index at the beginning
                    let rowMultiplier = columnRange * i - 1;

                    //start with direction
                    if (subIndexCollection.currentSubIndex > 0) {
                        currentSub.current_Subscriber_ID = rawCellArray[(rowMultiplier + subIndexCollection.currentSubIndex)].toString().toUpperCase();
                    }

                    //map type
                    if (subIndexCollection.newSubIndex > 0) {
                        currentSub.new_Subscriber_ID = rawCellArray[(rowMultiplier + subIndexCollection.newSubIndex)].toString();
                    }

                    currentSub.vbasoftware_database = currentDB;

                    currentSub.vbapi_Token = getWithExpiry('vbapi_Token');

                    if(currentSub.current_Subscriber_ID.length > 0 && currentSub.new_Subscriber_ID.length > 0){
                        subArray.push({...currentSub});
                    }
                    else {
                        // setValidationText("Group ID, Plan ID, and Vendor are required.");
                        // setValidationError(true);
                    }

                    currentSub.current_Subscriber_ID = initialSubState.current_Subscriber_ID;
                    currentSub.new_Subscriber_ID = initialSubState.new_Subscriber_ID;

                    clearSubs();
                }


                changeSubIDs(subArray);

                excelData.Sheets.SubIDs = undefined;
            }
            else {
                //setValidationText("Group ID, Plan ID, and Vendor are required.");
                //setValidationError(true);
            }

        }
    }
    catch(e) {
        console.log("ERROR", e);

        setErrorAlert(true);
        //clear it out after errors in case of rerendering otherwise the error spams will continue until morale improves
        excelData.Sheets.SubIDs = undefined;
    }

    return (
        <div>
            {successAlert ? <Alert className="groupAlertStyles" severity='success' onClose={() => setSuccessAlert(false)} variant="filled">
                <AlertTitle>Success!</AlertTitle>
                Sub ID Update Complete!
            </Alert> : <></> }
            {errorAlert ? <Alert className="groupAlertStyles" severity='error' onClose={() => setErrorAlert(false)} variant="filled">
                <AlertTitle>Error!</AlertTitle>
                There was an error with this file!
            </Alert> : <></> }
            <Dialog
                open={validationError}
                onClose={handleValidationClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">
                    {"Validation Error"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {validationText}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleValidationClose}>OK</Button>
                </DialogActions>
            </Dialog>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={isLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    );
}

export default React.memo(SubscriberIDChanger)

SubscriberIDChanger.propTypes = {
    excelData: PropTypes.object.isRequired
};
